import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

const CAMPAIGN_ACCESS_PERMISSIONS = [
  'campaign:manage',
  'campaign:create',
  'campaign:update',
  'campaign:publish',
  'campaign:view',
];

export const campaignManageGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const user = auth.user();

  if (
    user?.roleCode !== 'SUPER_ADMIN' &&
    auth.hasAnyPermission(CAMPAIGN_ACCESS_PERMISSIONS)
  ) {
    return true;
  }

  return router.createUrlTree(['/dashboard']);
};

